module.exports = __webpack_public_path__ + "img/pause_stream.3d78bc27.svg";